/**
 * Shop archive:
 *  - Filter bar popovers + all-filters drawer
 *  - Price range dual-slider
 *  - View toggle (4 / 5 column grid)
 *  - AJAX load more — fetches the next paginated page, extracts the new
 *    product cards and appends them to the existing grid, then swaps the
 *    load-more section. Active filter params are preserved because the
 *    server-rendered "next page" URL already includes them.
 */
function initShop() {

    // ── View toggle ───────────────────────────────────────────────────────────
    var toggleBtns = document.querySelectorAll('[data-grid-view]');
    var grid       = document.querySelector('ul.products, .product-grid');

    toggleBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var cols = parseInt(btn.dataset.gridView, 10);
            toggleBtns.forEach(function(b) { b.classList.remove('on'); });
            btn.classList.add('on');
            if (grid) grid.classList.toggle('compact', cols === 5);
        });
    });

    // ── Filter bar popovers ───────────────────────────────────────────────────
    var fWraps = document.querySelectorAll('.fwrap');

    fWraps.forEach(function(wrap) {
        var btn     = wrap.querySelector('.fbtn');
        var popover = wrap.querySelector('.popover');
        if (!btn || !popover) return;

        btn.addEventListener('click', function(e) {
            e.stopPropagation();
            var wasOpen = wrap.classList.contains('open');
            fWraps.forEach(function(w) {
                w.classList.remove('open');
                var b = w.querySelector('.fbtn');
                if (b) b.classList.remove('open');
            });
            if (!wasOpen) { wrap.classList.add('open'); btn.classList.add('open'); }
        });

        popover.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    document.addEventListener('click', function() {
        fWraps.forEach(function(w) {
            w.classList.remove('open');
            var b = w.querySelector('.fbtn');
            if (b) b.classList.remove('open');
        });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            fWraps.forEach(function(w) {
                w.classList.remove('open');
                var b = w.querySelector('.fbtn');
                if (b) b.classList.remove('open');
            });
        }
    });

    // ── Price range dual-slider ───────────────────────────────────────────────
    var rangeMin = document.getElementById('priceRangeMin');
    var rangeMax = document.getElementById('priceRangeMax');
    var labelMin = document.getElementById('priceMinLabel');
    var labelMax = document.getElementById('priceMaxLabel');

    if (rangeMin && rangeMax) {
        rangeMin.addEventListener('input', function() {
            if (parseInt(rangeMin.value, 10) > parseInt(rangeMax.value, 10)) rangeMax.value = rangeMin.value;
            if (labelMin) labelMin.textContent = rangeMin.value + ' kr';
        });
        rangeMax.addEventListener('input', function() {
            if (parseInt(rangeMax.value, 10) < parseInt(rangeMin.value, 10)) rangeMin.value = rangeMax.value;
            if (labelMax) labelMax.textContent = rangeMax.value + ' kr';
        });
    }

    // ── All-filters drawer ────────────────────────────────────────────────────
    var afOverlay     = document.getElementById('afOverlay');
    var afDrawer      = document.getElementById('allFilters');
    var openAllBtn    = document.getElementById('openAllFilters');
    var closeAllBtn   = document.getElementById('closeAllFilters');
    var mobileTrigger = document.getElementById('mobileFilterTrigger');

    function openDrawer() {
        if (!afDrawer) return;
        afDrawer.classList.add('open');
        if (afOverlay) afOverlay.classList.add('on');
        afDrawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
        if (!afDrawer) return;
        afDrawer.classList.remove('open');
        if (afOverlay) afOverlay.classList.remove('on');
        afDrawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
    }

    if (openAllBtn)    openAllBtn.addEventListener('click', openDrawer);
    if (mobileTrigger) mobileTrigger.addEventListener('click', openDrawer);
    if (closeAllBtn)   closeAllBtn.addEventListener('click', closeDrawer);
    if (afOverlay)     afOverlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && afDrawer && afDrawer.classList.contains('open')) closeDrawer();
    });

    // ── AJAX load more ────────────────────────────────────────────────────────
    //
    // How it works:
    //  1. User clicks "Vis N varer mere" — the <a> href already contains the
    //     next-page URL with ALL active filter params (e.g. ?filter_size=m&paged=2).
    //  2. We fetch that URL server-side and parse the HTML response.
    //  3. New <li class="product"> cards are appended to the existing ul.products.
    //  4. The .load-more section is replaced with the new one from the response
    //     (updated counts + next-page URL, or "all loaded" message).
    //
    // Filters continue to work: clicking a filter navigates the page normally
    // (server-side URL change), starting from page 1 of the filtered results.

    document.addEventListener('click', function(e) {
        var btn = e.target.closest('a.load-more-btn');
        if (!btn) return;

        e.preventDefault();

        var url          = btn.href;
        var loadMoreWrap = btn.closest('.load-more');
        var productGrid  = document.querySelector('ul.products');

        if (!url || !productGrid) return;

        // Loading state — disable button and show feedback
        btn.classList.add('loading');
        btn.textContent = 'Henter…';     // "Loading…" in Danish
        btn.style.pointerEvents = 'none';

        fetch(url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function(response) {
            if (!response.ok) throw new Error('Network error ' + response.status);
            return response.text();
        })
        .then(function(html) {
            var parser  = new DOMParser();
            var doc     = parser.parseFromString(html, 'text/html');

            // Append new product cards
            var newCards = doc.querySelectorAll('ul.products li.product');
            newCards.forEach(function(card) {
                productGrid.appendChild(card);
            });

            // Swap the load-more section (new counts + next URL, or "all loaded")
            var newLoadMore = doc.querySelector('.load-more');
            if (loadMoreWrap) {
                if (newLoadMore) {
                    loadMoreWrap.innerHTML = newLoadMore.innerHTML;
                } else {
                    // No more pages — remove the load-more entirely
                    loadMoreWrap.remove();
                }
            }

            // Maintain the current compact/4-col view state on new cards
            // (the grid already has .compact or not, so no action needed)

            // Let YITH WooCommerce Wishlist know about new DOM elements
            if (typeof jQuery !== 'undefined') {
                jQuery(document.body).trigger('yith_wcwl_init');
            }
        })
        .catch(function() {
            // Network failure — fall back to regular page navigation
            window.location.href = url;
        });
    });
}
